module.exports = __webpack_public_path__ + "img/clock.66401c98.svg";